import type React from 'react'
import { Footnote } from './Footnote'

type props = { links: string[]; className?: string }
export const FootnoteList: React.FC<props> = ({ className, links }) => {
  return (
    <div className={`${className} inline`}>
      {links.map((link) => (
        <Footnote key={link} link={link} />
      ))}
    </div>
  )
}
